import React from 'react';
import { Card, Button, Icon } from '@weezevent/nacre';
import { BuildingIcon } from './BuildingIcon';
import { DefinitionsList } from '../../../components/DefinitionsList';
import { useTranslation } from 'react-i18next';
import { useEditEntityDrawer } from './useEditEntityDrawer';
import classes from './EntityOverview.module.scss';
import { useStore } from '../../store';

const getFullName = (firstName, lastName) => {
    return [firstName, lastName].filter(Boolean).join(' ');
};

export const EntityOverview = () => {
    const { t } = useTranslation();

    const {
        financeEntity: { data }
    } = useStore();

    const editEntityDrawer = useEditEntityDrawer();

    return (
        <>
            <Card>
                <Card.Header className={classes.cardHeader}>
                    <Card.Title>{t('sauron.financeModule.entityOverview.title')}</Card.Title>
                    <Button basic as="button" className={classes.editButton} onClick={() => editEntityDrawer.open(data)}>
                        <Icon name="edit" />
                        {t('sauron.financeModule.entityOverview.editCta')}
                    </Button>
                </Card.Header>
                <Card.Content className={classes.overviewContent}>
                    <BuildingIcon className={classes.buildingIcon} />
                    <DefinitionsList
                        list={[
                            {
                                key: 'entity-name',
                                term: t('sauron.financeModule.entityOverview.terms.entityName'),
                                definition: data?.name
                            },
                            {
                                key: 'mainContact',
                                term: t('sauron.financeModule.entityOverview.terms.mainContact'),
                                definition: getFullName(data?.main_contact_first_name, data?.main_contact_last_name)
                            },
                            {
                                key: 'email',
                                term: t('sauron.financeModule.entityOverview.terms.mainContactEmail'),
                                definition: data?.main_contact_email
                            },
                            {
                                key: 'phone',
                                term: t('sauron.financeModule.entityOverview.terms.mainContactPhoneNumber'),
                                definition: data?.main_contact_phone_number
                            }
                        ]}
                    />
                </Card.Content>
            </Card>
            {editEntityDrawer.render()}
        </>
    );
};
